export default __webpack_public_path__ + "static/media/srednoy_grishin.15aeeba6.jpg";